import React from 'react';
import { getHomeInfo } from 'api/provider';
import { HomeInfo } from 'types/provider';
import HomeStore from 'store/Home';
import { checkIsRegularUser } from 'utils/common';
import { isOpPortal } from 'api';
import { getUserToken } from 'utils/localstore';
import { getCookieProviderToken, setCookieProviderToken, setCookieProviderTokenSetTime } from 'utils/shareAccount';

let globalData: HomeInfo | undefined;
const useProviderHomeInfo = (
    // eslint-disable-next-line @typescript-eslint/comma-dangle
    isOperation?: boolean,
): [HomeInfo | undefined, boolean, () => void] => {
    const [, setHomeStore] = HomeStore.useStore();
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<HomeInfo | undefined>(globalData);
    //api data isKlarityWebsiteProvider is false, but we need to set it to true for ppa provider
    const fetchData = async () => {
        try {
            setLoading(true);
            //admin-server/provider/home?providerId=xxx
            const result = await getHomeInfo();
            if (!result.error) {
                const data: HomeInfo = result?.data?.data;
                const token = getUserToken();
                if (token) {
                    const cookieProviderToken = getCookieProviderToken();
                    if (token !== cookieProviderToken) {
                        setCookieProviderToken(token);
                        setCookieProviderTokenSetTime(new Date().getTime());
                    }
                }
                let resData: HomeInfo | undefined = data;
                if (data) {
                    resData = {
                        ...data,
                        isRegularUser: checkIsRegularUser(data.signUpDate),
                    };
                }
                globalData = resData;
                setItems(resData);
                setHomeStore('reload', false);
                setHomeStore('data', resData);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (!loading && !isOperation && !isOpPortal()) {
            fetchData();
        }
    }, []);

    return [items, loading, fetchData];
};

export default useProviderHomeInfo;
